module.exports = __webpack_public_path__ + "static/img/eu-logos.2815b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eu-logos.png
// module id = RN3v
// module chunks = 2